import { Link } from "react-router-dom";

const stats = [
  { value: "3", label: "核心内容频道" },
  { value: "20+", label: "精选示例内容" },
  { value: "每日", label: "更新娱乐动态" },
];

export default function SiteIntro() {
  return (
    <section
      aria-label="网站简介"
      className="relative overflow-hidden rounded-lg bg-foreground-900 text-background-50"
    >
      <img
        src="https://readdy.ai/api/search-image?query=warm%20abstract%20editorial%20background%20with%20soft%20amber%20gradient%20and%20subtle%20film%20grain%2C%20minimalist%20elegant%20texture%2C%20cinematic%20warm%20tone%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=700&seq=mitao33-intro-band&orientation=landscape"
        alt="蜜桃33 内容理念"
        title="蜜桃33 - 综合娱乐资讯平台"
        className="absolute inset-0 h-full w-full object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/50" />
      <div className="relative mx-auto flex w-full flex-col gap-8 p-8 md:p-12 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-semibold text-background-50">
            <i className="ri-quill-pen-line" />
            关于蜜桃33
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-tight text-balance md:text-3xl">
            用编辑的视角，陪你读懂每一份娱乐内容
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200/90 md:text-base">
            蜜桃33 是一个综合娱乐资讯平台，聚合娱乐新闻、影视推荐与明星动态三大频道。我们相信娱乐资讯也可以被认真对待——筛选有价值的信息，提供清晰的分类与阅读体验，让你用更少的时间获取更完整的娱乐视界。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/category/recommendations"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              浏览影视推荐
            </Link>
          </div>
        </div>

        <div className="grid w-full grid-cols-3 gap-4 lg:w-auto lg:grid-cols-1 lg:gap-5">
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg bg-background-50/10 p-4 text-center backdrop-blur lg:min-w-[180px] lg:text-left"
            >
              <p className="font-heading text-2xl font-bold text-primary-300">{item.value}</p>
              <p className="mt-1 text-xs text-background-200/80">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}